<template>
<div class="modal fade" id="modalWorkshiftDetail" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Detalhe completo do turno</h4>
      </div>

      <div class="modal-body">
        <div v-if="!workshift" class="empty">Selecione um turno para ver o detalhe.</div>

        <div v-else>
          <!-- Informações da empresa (CompanySetting) -->
          <h5 class="section-title">Empresa (CompanySetting)</h5>
          <table class="kv-table">
            <tr><th>{{ labels.companySettings.defaultTimeZone }}</th><td>{{ helpers.formatTimezoneFriendly(company.defaultTimeZone, timezones) }}</td></tr>
            <tr><th>{{ labels.companySettings.extraordinaryPhase }}</th><td>{{ helpers.getExtraordinaryPhaseLabel(company.extraordinaryPhase) }}</td></tr>
            <tr><th>{{ labels.companySettings.useExtraNight }}</th><td>{{ helpers.formatBool(company.useExtraNight) }}</td></tr>
            <tr><th>{{ labels.companySettings.extraNightInit }}</th><td>{{ helpers.formatTimeSpan(company.extraNightInit) }}</td></tr>
            <tr><th>{{ labels.companySettings.extraNightEnd }}</th><td>{{ helpers.formatTimeSpan(company.extraNightEnd) }}</td></tr>
            <tr><th>{{ labels.companySettings.applyRecalcPoints }}</th><td>{{ helpers.formatBool(company.applyRecalcPoints) }}</td></tr>
          </table>

          <!-- Informações do turno (Workshift) -->
          <h5 class="section-title">Turno (Workshift)</h5>
          <table class="kv-table">
            <tr><th>{{ labels.workShift.name }}</th><td>{{ workshift.name }}</td></tr>
            <tr><th>{{ labels.workShift.code }}</th><td>{{ workshift.code }}</td></tr>
            <tr><th>{{ labels.workShift.workShiftType }}</th><td>{{ helpers.getWorkShiftTypeLabel(workshift.workShiftType) }}</td></tr>
            <tr>
              <th>{{ labels.workShift.timeZone }}</th>
              <td>{{ helpers.formatInheritableTimezoneFriendly(workshift.timeZone, company.defaultTimeZone, timezones) }}</td>
            </tr>
            <tr><th>{{ labels.workShift.extraordinaryPhase }}</th><td>{{ helpers.getExtraordinaryPhaseLabel(workshift.extraordinaryPhase) }}</td></tr>
            <tr><th>{{ labels.workShift.useNightshiftPhase }}</th><td>{{ helpers.formatBool(workshift.useNightshiftPhase) }}</td></tr>
            <tr><th>{{ labels.workShift.nightshiftIInit }}</th><td>{{ helpers.formatTimeSpan(workshift.nightshiftIInit) }}</td></tr>
            <tr><th>{{ labels.workShift.nightshiftIEnd }}</th><td>{{ helpers.formatTimeSpan(workshift.nightshiftIEnd) }}</td></tr>
            <tr>
              <th>{{ labels.workShift.applyRecalcPoints }}</th>
              <td>{{ helpers.formatInheritableBool(workshift.applyRecalcPoints, company.applyRecalcPoints) }}</td>
            </tr>
            <tr><th>{{ labels.workShift.applyPercentagesToBalance }}</th><td>{{ helpers.formatBool(workshift.applyPercentagesToBalance) }}</td></tr>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  workShiftLabels,
  companySettingsLabels,
  labelHelpers
} from "../../../labels/workshiftLabels";

export default {
  name: "modalWorkshiftDetail",
  props: {
    workshift: { type: Object, default: null },
    company: { type: Object, default: () => ({}) },
    // dicionário { winName: "(GMT -03:00) Brasília" } pra exibição amigável.
    // Quem renderiza esse modal (configureHE3, etc.) passa o timezones que
    // já carregou via GET_TIMEZONE_LIST. Default vazio cai no nome Windows.
    timezones: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      labels: { workShift: workShiftLabels, companySettings: companySettingsLabels },
      helpers: labelHelpers
    };
  },
  methods: {
    closeModal() {
      $("#modalWorkshiftDetail").modal("toggle");
    }
  }
};
</script>

<style lang="scss">
#modalWorkshiftDetail {
  .modal-header { padding: 15px 15px 0; border-bottom: none; }
  .title-modal {
    text-align: center; padding-top: 10px; font-weight: bold;
    letter-spacing: 1px; text-transform: uppercase;
  }
  .modal-body { padding: 20px 40px; }
  .section-title {
    margin-top: 16px; margin-bottom: 8px; font-weight: 600; color: #444;
    border-bottom: 1px solid #eee; padding-bottom: 6px;
  }
  .kv-table {
    width: 100%; border-collapse: collapse; font-size: 13px;
    th, td { padding: 6px 8px; border-bottom: 1px solid #f0f0f0; text-align: left; }
    th { color: #777; font-weight: 500; width: 45%; }
    td { color: #222; }
  }
  .empty { text-align: center; color: #999; padding: 40px 0; }
  .modal-footer .close-btn {
    border-radius: 4px !important; background-color: #8b8787;
    padding: 7px 35px; font-weight: 600; color: #fff; border: none; height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalWorkshiftDetail.vue